<template>
  <section
    v-touch:swipe.prevent="preventDesktop(swipe)"
    class="sidearm-mm-hero-sunday mobile text-white relative bg-size-cover bg-position-center relative overflow-hidden h-100"
    data-anchor="home"
    scrolling
  >
    <section-background css_var="--section-mobile-bg-selection-sunday-hero"></section-background>
    <video-background
      v-if="section.background_type === 'video'"
      :video="section.background_video"
    />

    <background-element
      class="sidearm-mm-hero-sunday__background-element col-3-of-8 absolute"
    />

    <div class="h-100 sidearm-mm-hero-sunday__inner relative">
      <transition :name="panel_transition">
        <div v-show="swipe_step === 0" class="h-100 relative">
          <div
            class="sidearm-mm-hero-sunday__details w-100 h-100 px-4 py-10 flex flex-column flex-align-start flex-justify-end"
          >
            <ad
              name="tournament-experience-cs-hero-1"
              :sport-id="$root.sport_id"
              class="mb-2"
            />
            <!-- <img src="https://dummyimage.com/150x50/1C453B/ffffff" alt="" /> -->

            <h2 class="type-heading-bracket-plain --light ma-0 my-2">
              Selection {{ this.$root.selection_day_text }}
            </h2>

            <h3
              v-if="section.title"
              class="type-hero mt-0 mb-4"
              :class="{ '--long': section.title.length > 16 }"
            >
              {{ section.title }}
            </h3>

            <button
              @click="swipe_up"
              type="button"
              class="sidearm-mm-hero-sunday__start-btn absolute reset"
            >
              <span class="block pa-1">
                <img src="~@/assets/outlined_basketball.svg" alt="" />
              </span>
            </button>
          </div>
        </div>
      </transition>

      <div
        v-show="swipe_step === 1"
        class="h-100 flex flex-column flex-justify-end"
      >
        <transition v-if="section.sub_title" :name="panel_transition">
          <div class="sidearm-mm-hero-sunday__subtitle-container">
            <p
              class="type-paragraph-large ma-0 w-100 pa-4"
            >
              {{ section.sub_title }}
            </p>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
import BackgroundElement from "@/components/Globals/BackgroundElement";

export default {
  props: {
    section: { type: Object, required: true }
  },

  components: {
    BackgroundElement
  },

  data: () => ({
    swipe_step: 0,
    swipe_direction: "",
    panel_transition: "down"
  }),

  computed: {
    swipe_intervals() {
      let intervals = 0;

      if (this.section.sub_title) {
        ++intervals;
      }

      return intervals;
    }
  },

  methods: {
    swipe(direction) {
      if (direction === "top") {
        this.swipe_up();
      } else if (direction === "bottom") {
        this.swipe_down();
      }
    },

    swipe_down() {
      if (this.swipe_step === 0) {
        this.moveSectionUp();
      } else {
        this.panel_transition = "up";

        if (this.swipe_step === 1 && !this.section.subtitle) {
          this.swipe_step--;
        }
        this.swipe_step--;
      }

      if (this.swipe_step < 0) {
        this.swipe_step = 0;
      }
    },

    swipe_up() {
      if (this.swipe_step >= this.swipe_intervals) {
        this.moveSectionDown();
      } else {
        this.panel_transition = "down";

        ++this.swipe_step;

        if (this.swipe_step > this.swipe_intervals) {
          this.swipe_step = this.swipe_intervals;
        }
      }
    }
  },
  mounted() {
    this.selection_day_text = this.$root.selection_day_text;
  }
};
</script>

<style lang="scss" scoped>
.#{$prefix}-hero-sunday.mobile {

  .#{$prefix}-hero-sunday {
    &__start-btn {
      display: inline-block;
      left: 50%;
      bottom: 60px;
      transform: translateX(-50%);

      &::after {
        background-color: $color-white;
        content: "";
        display: block;
        height: 60px;
        left: 50%;
        position: absolute;
        top: 100%;
        transform: translateX(-50%);
        width: 1px;
      }

      > span {
        border-radius: 50%;
        border: 1px solid $color-white;
      }
    }
  }
}
</style>

<style lang="scss">
.#{$prefix}-hero-sunday.mobile {
  .up-enter-active,
  .up-leave-active {
    transition: all 0.5s ease;
  }
  .up-enter {
    transform: translateY(-25%);
    opacity: 0;
  }
  .up-leave-to {
    transform: translateY(25%);
    opacity: 0;
  }

  .down-enter-active,
  .down-leave-active {
    transition: all 0.5s ease;
  }
  .down-enter {
    transform: translateY(25%);
    opacity: 0;
  }
  .down-leave-to {
    transform: translateY(-25%);
    opacity: 0;
  }
}
</style>
